<template>
        <Menubar class="mobileMenu" :model="MenubarData" />
        <div 
            class="productMenu" 
            :class="{ 'productMenuVisible': true }"
            :style="{
                transition: scrollTop > 0 ? '0s' : '.3s',
                background: backgroundColor,
                // 'border-bottom': backgroundColor === '#FFFFF' ? '1px solid rgb(230, 230, 230)' : '1px solid rgb(230, 230, 230)'
            }"
        >
            <div class="menuBody" :style="customWidth">
                <!-- <img 
                    class="backArrow"
                    @click="toPreviousPage"
                    :src="require('../../../../assetsUniversal/icons/left-arrow.svg')" 
                    alt=""
                > -->
                <!-- <img 
                    class="coverImg" 
                    v-if="shopData.coverImg"
                    :src="`${$fetchIp}/static/images/shops/${shopData.coverImg}`"
                > -->
                <img 
                    class="logoSmall"
                    :src="require('../../assets/vegotarLong.png')" 
                    alt=""
                >
                <div class="menuLinks">
                    <!-- <Button size="large" @click="$emit('showCategoriesDrawer')" style="height: 40px; margin-top: auto; margin-bottom: auto; background-color: white;" severity="contrast" rounded icon="pi pi-bars" outlined label="Kategooriad" /> -->
                    <Button @click="$router.push({ name: 'shopLanding' })" size="large" severity="info" rounded icon="pi pi-home" text :label="$t('buttons.home')" />
                    <!-- <Button @click="$router.push({ name: 'catalogPage' })" size="large" severity="info" rounded icon="pi pi-shopping-cart" text :label="$t('buttons.shop')" /> -->
                    <!-- <Button @click="$router.push({ name: 'referencesPage' })" size="large" severity="info" rounded icon="pi pi-hammer" text :label="$t('buttons.references')" /> -->
                    <Button @click="$router.push({ name: 'contactPage' })" size="large" severity="info" rounded icon="pi pi-address-book" text :label="$t('buttons.contact')" />
                </div>
                <div class="btns">
                    <Button  severity="info" style="background: steelblue; border: 1px solid steelblue" icon="pi pi-phone" :label="$t('buttons.contactUsAlt')" @click="$emit('openContactPopup')" />
                </div>
                <div class="switcher">
                    <languageSwitcher />
                </div>
            </div>
        </div>
</template>

<script>
import Button from 'primevue/button';
import Menubar from 'primevue/menubar';
import languageSwitcher from '../languageSwitcher.vue';

export default {
    name: 'catalogMenu',
    components: {
        Button,
        Menubar,
        languageSwitcher
    },
    props: {
        shopData: null,
        listingsData: Array,
        feedbackStats: Object,
        currentRouteName: null,
        backgroundColor: {
            default: '#FFFFF'
        },
        customWidth: {
            default: 'width: 1100px'
        }
    },
    data() {
        return {
            categoriesDrawer: false,
            MenubarData: [
                {
                    label: this.$t('buttons.home'),
                    icon: 'pi pi-home',
                    command: () => {
                        this.$router.push({ name: 'shopLanding' });
                    }
                },
                // {
                //     label: this.$t('buttons.shop'),
                //     icon: 'pi pi-shopping-cart',
                //     command: () => {
                //         this.$router.push({ name: 'catalogPage' });
                //     }
                // },
                {
                    label: this.$t('buttons.contact'),
                    icon: 'pi pi-phone',
                    command: () => {
                        this.$router.push({ name: 'contactPage' });
                    }
                }
            ]
        };
    },
    watch: {
        // listingsData: {
        //     handler(newVal) {
        //         if (newVal) {
        //             this.listingCategories();
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        
    },

    created() {
        
    }
};
</script>
<style>
.p-menubar {
    --p-menubar-border-color: white;
    width: 100%;
}
</style>
<style scoped>
.productMenu {
    position: absolute;
    z-index: 1050;
    top: -165px;
    left: 0;
    width: 100%;
    /* border-bottom: 1px solid rgb(230,230,230); */
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    padding: 5px 0px 5px 0px;
}
.productMenuVisible {
    top: 0px;
}
.logoSmall {
    position: absolute;
    margin-top: 10px;
    width: 250px;
}
.productMenuVisible.vue-fixed-header--isFixed {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0px;
    z-index: 1050;
}
.menuBody {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;
}
.backArrow {
    position: absolute;
    left: -50px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 25px;
    width: 42px;
    cursor: pointer;
}
.btns {
    margin-top: auto;
    margin-bottom: auto;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin-left: 25px;
}
.categoryList {
    margin-left: 15px;
    margin-top: 10px;
    height: 40px;
}
.menuLinks {
    margin-left: auto;
    padding-top: 17px;
    padding-bottom: 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-column-gap: 10px;
       -moz-column-gap: 10px;
            column-gap: 10px;
}
.menuLinks button {
    color: steelblue;
}
.mobileMenu {
    display: none;
}
.switcher {
    position: absolute;
    right: 0;
    top: 70px;
}
@media (max-width: 1320px) {
    .mobileMenu {
        position: absolute;
        z-index: 100000;
        top: 0;
        left: 0;
        display: initial;
    }
    .productMenu {
        display: none;
    }
}
</style>